<ll-titulo>Reforzamientos</ll-titulo>
<plan-personal-avance-grupo-usuario [estadisticas]="statsAlumnos"></plan-personal-avance-grupo-usuario>
